export function requiredRule() {
    return function (input) { return !!input || "入力してください"; };
}
//# sourceMappingURL=required.js.map